// src/components/Routee/EditRouteeModal.jsx
import React, { useEffect, useState } from 'react';

const EditRouteeModal = ({ isOpen, onClose, onSave, route, isSaving }) => {
  const [formData, setFormData] = useState({ name: '', isActive: true });

  useEffect(() => {
    if (isOpen && route) {
      // Only update when modal is open and route exists
      setFormData({
        name: route.name || '',
        isActive: Boolean(route.isActive),
      });
    } else if (isOpen && !route) {
      // Reset for new route
      setFormData({ name: '', isActive: true });
    }
  }, [isOpen, route]); // Changed from routee to route

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prev) => ({ ...prev, [name]: checked }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.name.trim()) {
      alert('Please enter a route name');
      return;
    }

    onSave({ name: formData.name, isActive: formData.isActive });
  };

  const handleClose = () => {
    if (isSaving) return;
    setFormData({ name: '', isActive: true });
    onClose();
  };

  return (
    <div className="inventory-modal-overlay">
      <div className="inventory-modal-content">
        <header className="inventory-modal-header">
          <h3 className="inventory-modal-title">
            {route ? `Edit Route: ${route.name}` : 'Edit Route'}
          </h3>
          <button
            className="inventory-close-modal-btn"
            onClick={handleClose}
            disabled={isSaving}
            type="button"
          >
            ×
          </button>
        </header>

        <div className="inventory-modal-body">
          <form id="routeeForm" onSubmit={handleSubmit}>
            <div className="inventory-form-grid">
              <label htmlFor="name">
                Route Name <span style={{ color: 'red' }}>*</span>
              </label>
              <input
                type="text"
                id="name"
                name="name"
                className="inventory-custom-input"
                placeholder="e.g., L-10"
                value={formData.name}
                onChange={handleChange}
                required
                disabled={isSaving}
                autoFocus
              />

              <label htmlFor="isActive">Active</label>
              <input
                type="checkbox"
                id="isActive"
                name="isActive"
                checked={formData.isActive}
                onChange={handleCheckboxChange}
                disabled={isSaving}
              />
            </div>
          </form>
        </div>

        <footer className="inventory-modal-footer">
          <button
            className="inventory-btn inventory-btn-cancel"
            onClick={handleClose}
            disabled={isSaving}
            type="button"
          >
            Cancel
          </button>
          <button
            className="inventory-btn inventory-btn-save"
            disabled={isSaving}
            type="submit"
            form="routeeForm"
          >
            {isSaving ? 'Saving...' : 'Save Route'}
          </button>
        </footer>
      </div>
    </div>
  );
};

export default EditRouteeModal;